import React, { Component } from "react";
import { Trans } from 'lingui-react';

import { Table } from 'reactstrap';
import { Button } from '../../components/Button/index';

import { getMyAccount, getAssessments, getCompanyById, getAssessmentReportFile, setCookieCompanyId } from '../../services/index'

import './assessmentManager.css'

export default class AssessmentManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assessmentsList: [],
      releaseVersion: document.getElementById('releaseVersion').innerHTML
    }
  }

  componentWillMount() {
    if (!this.props.keyCloak.hasRealmRole('admin')) {
      this.props.history.push('/dashboard')
    }
  }

  componentDidMount() {
    this.buildAssessmentListByCompany();
  }

  buildAssessmentListByCompany() {
    getMyAccount().then(account => {
      getAssessments().then(assessments => {
        Promise.all(assessments
          .map(assessment =>
            this.getCompanyAssessmentResult(assessment.companyId, assessment._id, assessment.reportFileId, account.companyIds.includes(assessment.companyId))
          )
        ).then(result => {
          this.setState({
            assessmentsList: result
          })
        }).catch(e => console.log(e))
      })
    })
  }

  getAllAssessment() {
    return new Promise((resolve, reject) => {
      getAssessments().then(assessments => {
        resolve(assessments);
      }).catch(e => reject(e))
    })
  }

  getCompanyAssessmentResult(companyId, assessmentId, reportFileId, isAccountCompany) {
    return new Promise((resolve, reject) => {
      getCompanyById(companyId).then(company => {
        resolve({
          companyId: companyId,
          companyName: company.companyName,
          assessmentId: assessmentId,
          reportFileId: reportFileId,
          isAccountCompany: isAccountCompany
        });
      }).catch(e => reject(e))
    })
  }

  exportPdf(reportFileId) {
    return getAssessmentReportFile(reportFileId);
  }

  handleClickNewCompany = () => {
    this.props.history.push('/company?new');
  };

  navigateToDashboard = (companyId) => {
    setCookieCompanyId(this.props.cookies, companyId);
    this.props.history.push('/dashboard');
  }

  render() {
    let contentTable = null;
    if (this.state.assessmentsList.length != null) {
      contentTable = this.state.assessmentsList.map((element, index) => {
        let reportLink = null;
        if (element.reportFileId) {
          let hrefPdf = this.exportPdf(element.reportFileId);
          reportLink = <a href={hrefPdf}><Trans id="PDF" /></a>
        } else {
          reportLink = <Trans id="n/a" />
        }
        let companyLink = null;
        if (element.isAccountCompany) {
          companyLink = <a href="#" onClick={() => { this.navigateToDashboard(element.companyId) }}>{element.companyName}</a>
        } else {
          companyLink = <span>{element.companyName}</span>
        }

        return (
          <tr key={index}>
            <th scope="row">{index + 1}</th>
            <td>{companyLink}</td>
            <td>{reportLink}</td>
          </tr>
        )
      })
    }
    else {
      contentTable = <tr key={0}>
        <td className="text-center" colSpan="3"><Trans id="No assessment found" /></td>
      </tr>
    }
    let addNewCompanyButton = <Button
      text={<Trans id="+ Add new company" />}
      onClick={this.handleClickNewCompany}
      styleButton="button-add-company"
    />
    return (
      <div key={1} className="assessment-manager-container">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="assessment-manager-header"><Trans id="Assessment Manager" /></h2>
            </div>
            <div className="col-md-12">
              {addNewCompanyButton}
            </div>
            <div className="col-md-12">
              <p></p>
            </div>
            <div className="col-md-12">
              <div className="assessment-table">
                <Table hover className="">
                  <thead>
                    <tr>
                      <th><Trans id="#" /></th>
                      <th><Trans id="Company Name" /></th>
                      <th><Trans id="Download" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {contentTable}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="col-md-12 d-flex flex-row justify-content-center">
              <p className="version text-center"><Trans id="Security Selfie v" /> {this.state.releaseVersion}</p>
            </div>
          </div>
        </div>
      </div >
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/AssessmentManager/AssessmentManager.js